import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppService } from './app.service';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class LocalizationService { private translations: { [key: string]: string } = {};
private translationsLoaded: BehaviorSubject<boolean> = new BehaviorSubject(false);
public translationsSubject = new BehaviorSubject<any[]>([]);
public translationsUpdated: BehaviorSubject<boolean> = new BehaviorSubject(false);



  constructor(private appService: AppService, private translocoService: TranslocoService) {}

  loadTranslations() {
    
    this.appService.getTranslations().subscribe({
      next: (res) => {
        this.translations = res.data; // Store translations in memory
        console.log(this.translations); 
        res.data.forEach((locale) => {
          const translationObject = this.convertToTranslocoFormat(locale.texts);
          this.translations[locale.culture] = translationObject;


          console.log("translation object is", translationObject)
          // Dynamically set translations in Transloco
          this.translocoService.setTranslation(translationObject, locale.culture);
        });

      },
      error: (err) => {
        console.log(err); 
      },
    });
    return this.translationsSubject.asObservable();
  }

  // Convert API response to Transloco's expected format
  private convertToTranslocoFormat(texts: { name: string; value: string }[]): any {
    const translationObject: any = {};
    texts.forEach((text) => {
      translationObject[text.name] = text.value;
    });
    return translationObject;
  }

  // Switch the active culture in Transloco
  switchCulture(culture: string): void {
    if (this.translations[culture]) {
      this.translocoService.setActiveLang(culture);
    } else {
      console.warn(`Culture ${culture} not found in translations.`);
    }
  }
 
  translate(key: string): string {
    return this.translations[key] || key;  // Fallback to the key if no translation is found
  }

  isTranslationsLoaded(): Observable<boolean> {
    return this.translationsLoaded.asObservable();
  }
}